<div class="plan-selector">
  <div *ngIf="!loading" class="plan-header">
    <p>Do you prefer to modify an existing plan or start a new one?</p>
    <p>Here is a list of plans already scheduled for this inspection type.</p>
  </div>
  
  <div *ngIf="loading" class="loading">
    <i class="fa fa-spinner fa-pulse"></i>
  </div>
  
  <div *ngIf="!loading" class="plans-list">
    <div *ngFor="let plan of inspectionPlans" 
         class="plan-item" 
         (click)="selectPlan(plan)">
      {{plan.assetWindowStartsAt | date:'shortDate'}} - {{plan.assetWindowEndsAt | date:'shortDate'}}
    </div>
  </div>

  <div *ngIf="!loading" class="create-new-plan">
    <button class="create-new-plan-button" (click)="selectPlan(null)">Create New Plan</button>
  </div>
</div> 